<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile() && $modalIsVisible()) {
<lib-bottom-sheet
  [visible]="$modalIsVisible()"
  (visibleChange)="$modalIsVisible.set($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  [headerTemplate]="headerTemplate ?? undefined"
  [footerTemplate]="footerTemplate ?? undefined"
  (hide)="fecharModal()"
>
  <lib-agenda-informacao-agendamento
    [agendamento]="agendamento"
    [showCloseButton]="false"
    (headerTemplateAction)="headerTemplateAction($event)"
    (footerTemplateAction)="footerTemplateAction($event)"
    (fechar)="fecharModal()"
  ></lib-agenda-informacao-agendamento>
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [visible]="$modalIsVisible()"
  (visibleChange)="$modalIsVisible.set($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [showHeader]="true"
  styleClass="dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ height: '660px', width: '700px' }"
  (onHide)="fecharModal()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </ng-template>

  @if ($modalIsVisible()) {
  <lib-agenda-informacao-agendamento
    [agendamento]="agendamento"
    (headerTemplateAction)="headerTemplateAction($event)"
    (footerTemplateAction)="footerTemplateAction($event)"
    (fechar)="fecharModal()"
  ></lib-agenda-informacao-agendamento>
  }

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</p-dialog>
}
